export { useGetDataByUrl } from './useGetDataByUrl'
